<template lang="jade">
  div.Form__wrapper(style="margin-top: 0; margin-bottom: 0; padding-top: 0; padding-bottom: 0")
    fieldset.Fieldset.Fieldset--collapsable(":id"="identity"
                                            style="margin-top: 0; margin-bottom: 0; padding-top: 0; padding-bottom: 0")
      div.Tag(v-for="item in tags")
        div.Tag__line {{ item | tagline }}
        div.Tag__action(@click="edit($index)")
      header.Fieldset__header(@click="toggle")
        div.Fieldset__icon
        h4.Fieldset__heading {{ fdata.label }}
        div.Fieldset__toggle
          span(v-bind:class="{'Fieldset__open': show, 'Fieldset__closed': !show}")
      div.Fieldset__body(class="animated" v-show="show" transition="fade")
          template(v-if="fdata.multi")
            component(is="type_multipart"
                      ":fdata"="fdata.content[0]")
          template(v-else)
            component(is="type_singlepart"
                      ":content"="fdata.content")
</template>

<script>
import _ from 'lodash'
import Moment from 'moment'

export default {
  data () {
    return {
      uid: this.$parent.uid,
      show: false,
      tags: []
    }
  },
  props: {
    fdata: {
      type: Object,
      coerce: x => {
        let {label} = x
        let content = x.content
        let multi = content.length === 1 && content[0].type === 'type_group'
        return {content, multi, label}
      },
      required: true
    }
  },
  computed: {
    identity () {
      return _.take(this.fdata.label.match(/\w+/g), 3).join('-')
    }
  },
  filters: {
    tagline (data) {
      return `${_.capitalize(data['W.CMS.MULTI.A.FIELD2'].toLowerCase())} ${data['W.CMS.MULTI.A.FIELD3']} ${data['W.CMS.MULTI.A.FIELD4']} - ${Moment(data['W.CMS.MULTI.D.FIELD5']).format('DD/MM/YYYY')}  - FREE`
    }
  },
  events: {
    'fdata::tags' (coll) {
      this.$set('tags', coll)
    },
    'collapse' (x) {
      let y = document.getElementById(this.identity).offsetTop
      window.scrollTo(0, y)
      this.$set('show', false)
    }
  },
  methods: {
    edit (idx) {
      this.$broadcast('fdata::edit', idx)
      this.$set('show', true)
    },
    toggle () {
      // window.scrollTo(window.scrollX, window.scrollY + 1)
      // if (!this.show) {
      //   setTimeout(() => {
      //     window.scrollTo(window.scrollX, window.scrollY - 1)
      //   }, 2000)
      // }
      this.show = !this.show
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// collapsable.vue?e9c07d58